import styled, { CSSProperties } from "styled-components";
import themeProps from "theme/themes";
import closeSquare from "assets/icons/close_square.svg";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

interface PopupProps {
  children: any;
  heading: string;
  handleSuccess?: any;
  handleWarning?: any;
  handleClose: any;
  successLabel?: string;
  warningLabel?: string;
  cancelLabel?: string;
  styles?: CSSProperties;
}

const Wrapper = styled.div`
  padding: 25px 30px;
  border-radius: 20px;
  background: ${(props: themeProps) => props.theme.background.primary};
  position: absolute;
  width: 80%;
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const Heading = styled.h2``;

const ContentWrapper = styled.div`
  max-height: 350px;
  overflow-y: scroll;
`;

const CloseButton = styled.button`
  background-image: url(${closeSquare});
  background-size: cover;
  background-color: transparent;
  cursor: pointer;
  background-repeat: none;
  border-radius: 12px;
  border: none;
  outline: none;
  width: 35px;
  height: 35px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
`;

const Popup = ({
  children,
  heading,
  handleSuccess,
  handleWarning,
  handleClose,
  successLabel,
  warningLabel,
  cancelLabel,
  styles,
}: PopupProps) => {
  const { t } = useTranslation("common");

  return (
    <Wrapper style={styles}>
      <Header>
        <Heading>{heading}</Heading>
        <CloseButton onClick={() => handleClose(false)} />
      </Header>
      <ContentWrapper>{children}</ContentWrapper>
      <ButtonsWrapper>
        <Button
          label={cancelLabel ? cancelLabel : t("back")}
          filled
          onClick={() => handleClose(false)}
          styles={
            warningLabel || successLabel
              ? { width: "50%", marginRight: "50px" }
              : { width: "50%", justifySelf: "center" }
          }
        />
        {warningLabel && (
          <Button
            label={warningLabel}
            filled
            onClick={handleWarning}
            color="#CE1C1C"
            styles={{ width: "50%" }}
          />
        )}
      </ButtonsWrapper>
    </Wrapper>
  );
};

export default Popup;
